import { NavLinks } from '@app/core/routing';
import { NavMenuItem } from './header-nav-menu-item.model';

/**
 * Link-only nav rows shared by the platform header menus. Action rows (fundraise,
 * dashboards) stay on the components that own the close/emit behaviour.
 *
 * Spread to vary a row per menu: `{ ...NAV_ITEMS.howItWorks, divider: true }`.
 */
export const NAV_ITEMS: Record<
  'discover' | 'howItWorks' | 'gbx' | 'charitySignup' | 'pricing' | 'support',
  NavMenuItem
> = {
  discover: { icon: 'compass', label: NavLinks.discover.label, link: NavLinks.discover.path },
  howItWorks: {
    icon: 'circle-play',
    label: NavLinks.howItWorks.label,
    link: NavLinks.howItWorks.path,
  },
  gbx: { icon: 'globe', label: NavLinks.gbx.label, link: NavLinks.gbx.path },
  charitySignup: {
    icon: 'plus',
    label: NavLinks.charitySignup.label,
    link: NavLinks.charitySignup.path,
  },
  pricing: { icon: 'credit-card', label: NavLinks.pricing.label, link: NavLinks.pricing.path },
  support: { icon: 'info', label: NavLinks.support.label, link: NavLinks.support.path },
};
